import { debounce } from 'throttle-debounce';
import axios from 'axios';
import $ from 'jquery';


export default class Search {
    constructor() {
        this.$body = document.body;
        this.$search = document.querySelector('.search');
        this.$searchTrigger = document.querySelector('.navigation__search');
        this.$searchInput = document.querySelector('.search__input');
        this.$searchClose = document.querySelector('.search__close');
        this.$autoComplete = document.querySelector('.search__autocomplete-wrap');
        this.$searchClear = document.querySelector('.search__clear-input');
        this.$searchForm = document.querySelector('.search__form');

        this.isSearchIsVisible = false; // flags handling information that layer with searchbar is visible

        if (!this.$search) {
            return;
        }

        this.init();
    }

    init() {
        this.eventToggleSearchLayer();
        this.eventSearchInput();
        this.eventClearSearchInput();
    }

    /**
     * Reset to default search window
     */
    clearView() {
        this.$autoComplete.style.display = 'none'; // hide autocomplete
        this.$search.querySelector('.search__form').reset(); // reset form
        this.toggleClearButton(false);
    }

    toggleAutoCompleteResult(data) {
        if (!data) {
            this.$autoComplete.style.display = 'none';
            return;
        }

        this.$autoComplete.style.display = 'block';

        this.$autoComplete.innerHTML = data;
    }

    toggleSearchLayer(status) {
        const $body = this.$body;
        const scrollWidth = window.innerWidth - document.documentElement.clientWidth; // width is needed to prevent a page bouncing

        if (status) {
            this.isSearchIsVisible = true;
            ['search--visible', 'scroll-hide'].forEach((cl) => $body.classList.add(cl));
            $body.style.paddingRight = scrollWidth + 'px';
        } else if (!status) {
            this.isSearchIsVisible = false;
            $body.style.paddingRight = null;
            ['search--visible', 'scroll-hide'].forEach((cl) => $body.classList.remove(cl));
            this.clearView();
        }
    }

    toggleClearButton(status) {
        if (status) {
            this.$searchClear.style.display = 'flex';
        } else if (!status) {
            this.$searchClear.style.display = 'none';
        }
    }

    eventSearchInput() {
        this.$searchInput.addEventListener('input', debounce(1000, () => { // debounce for searching in DB autocomplete
            if (!this.isSearchIsVisible || this.$searchInput.value.length === 0) { // don't show result when layer was closed or input is empty
                return;
            }

            this.getAutocompleteResults();
        }));

        this.$searchInput.addEventListener('input', () => { // withoout debounce for instant UI changes
            this.toggleClearButton(this.$searchInput.value.length > 0);
        });
    }

    getAutocompleteResults() {
        const value = this.$searchInput.value;
        const url = this.$searchForm.getAttribute('action');

        $.ajax({
            url: url,
            data: {'query': value},
            method: 'get',
            headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              'Pragma': 'no-cache',
              'Expires': '0'
            }
        })
            .then(result => {
                this.toggleAutoCompleteResult(result);
            })
            .catch(error => {
                console.log(error);
            });
    }

    eventToggleSearchLayer() {
        [this.$searchTrigger, this.$searchClose].forEach(($btn) => {
            $btn.addEventListener('click', () => {
                const isModalVisible = this.$body.classList.contains('search--visible');

                this.toggleSearchLayer(!isModalVisible);
            });
        })
    }

    eventClearSearchInput() {
        this.$searchClear.addEventListener('click', () => {
            this.$searchInput.value = '';
            this.$searchInput.focus();
            this.$autoComplete.style.display = 'none';
            this.toggleClearButton(false);
        });
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/search/Search.js